import { NavigateBackLink } from '@exam-center/components';
import { ExamEventCreationButton } from '@exam-center/exam-event-creation';
import { getExamEventDetailsTitle } from '@exam-center/exam-event-management';
import { ExamEventSchedule, ExamEventScheduleFiltersGroup } from '@exam-center/exam-event-schedule';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Box, Flex, PaperSection, PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function MonthlyExamSchedulePage() {
  const { examCenterCode, year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month',
  );

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <Box>
        {/* Header */}
        <PageHeader
          title={getExamEventDetailsTitle(parseInt(year), month)}
          linkAdornment={
            <NavigateBackLink
              to='/:examCenterCode/exam-events/years/:year'
              params={{ examCenterCode, year: year.toString(), month }}
              label='Back'
            />
          }
          endAdornment={
            <ExamEventCreationButton examCenterCode={examCenterCode} year={year} month={month} />
          }
        />

        {/* Content */}
        <Box sx={(theme) => ({ p: theme.spacing(6) })}>
          <PaperSection
            title='จัดการรอบสอบ'
            //TODO: Implement Publish Exam Event Button and unHide it */}
            // endAdornment={
            //   <Flex
            //     sx={(theme) => ({
            //       alignItems: 'center',
            //       gap: theme.spacing(4),
            //     })}
            //   >
            //     <Text>ยังไม่ประกาศรอบสอบ</Text>
            //     <Button variant='outlined'>ประกาศรอบสอบ</Button>
            //   </Flex>
            // }
          >
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                gap: theme.spacing(4),
                p: theme.spacing(6),
                width: '100%',
              })}
            >
              <ExamEventScheduleFiltersGroup />
              <ExamEventSchedule />
            </Flex>
          </PaperSection>
        </Box>
      </Box>
    </PermissionGuard>
  );
}
